import { Descriptions } from 'antd'
import React, { useState } from 'react'
import { $t } from '~/i18n.js'

import { useSelector } from 'react-redux'
import { CardBase } from "~/components/timeLine/cardBase.jsx";
import { _parseDate } from '~/lib/localize.js'
import { clubHasFlight } from '~/featureMatrix.jsx';
import { Tag } from 'antd';
import { HelpLine } from '~/components/help/helpLine.jsx';

export const CardConfirm = ({ data, saveData, saveAndNext, prev }) => {
  const [loading, setLoading] = useState(false)

  const { group_name_lookup } = useSelector((state) => state.flights)

  const handleSave = async () => {
    setLoading(true)
    data = await saveData(data)
    setLoading(false)
    if (data) saveAndNext()
  }

  return (
    <CardBase prev={prev} next={handleSave} title={$t('Opslaan')} loading={loading}>

      <Descriptions title={$t('Bevestig rooster periode')} size='small' bordered column={1} style={{marginBottom: 12}}>
        <Descriptions.Item label={$t('Rooster')}>{data.description}</Descriptions.Item>
        <Descriptions.Item label={$t('Data')}>
          {data.days.length} {$t('dagen')} <br />
          {clubHasFlight() && <>{data.is_vliegend ? $t('vliegend') : $t('niet vliegend')} <br /></>}
          {$t('van')} {_parseDate(data.date_from)} - {_parseDate(data.date_to)}
        </Descriptions.Item>
        
        <Descriptions.Item label={$t('Diensten')}>
          {data.roosters?.map((dienst, key) =>
            <p key={key}>{dienst.name} {dienst.delete && <Tag color='red'>{$t('Verwijderen')}</Tag>}</p>)}
          {data.roosters?.length === 0 && $t('Géén diensten')}
        </Descriptions.Item>

        <Descriptions.Item label={$t('Registratielijsten')}>
          {data.registration_lists.map((list, key) =>
            <p key={key}>{list.name} {list.cluster && <Tag>{list.cluster}</Tag>}</p>)}
          {data.registration_lists?.length === 0 && $t('Géén lijsten')}
        </Descriptions.Item>

        <Descriptions.Item label={$t('Checklists')}>
          {$t('Start')}: {data.checklist_start_day?.length || 0} {$t('items')}<br />
          {$t('Einde')}: {data.checklist_end_day?.length || 0} {$t('items')}
        </Descriptions.Item>

      </Descriptions>

    </CardBase>
  )
}
